module.exports = __webpack_public_path__ + "img/banner-pc-after.00e9ca5e.png";